import { SEARCH_DEFAULT_PAGE_SIZE } from '../../../../constants/person-constants';
import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';

const BASE = `${PORTAL_API_BASE_URL}/api/person`;

const req = (opts) => request({ ...opts, throw400Error: true });

/**
 * @param {{ q: string, page?: number, pageSize?: number }} params
 * @returns {Promise<{ results: Array, page: number, pageSize: number, totalCount: number, totalPages: number }>}
 */
export function searchPersons({ q, page = 1, pageSize = SEARCH_DEFAULT_PAGE_SIZE }) {
  const qs = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    q: q || '',
  });
  return req({ url: `${BASE}/search?${qs.toString()}`, method: 'GET' });
}
